export const PERMISSION_DESCRIPTIONS: Record<string, string> = {
  'role.view': 'Melihat daftar dan detail role',
  'role.manage': 'Membuat, mengubah, dan menghapus role',
  'permission.view': 'Melihat daftar permission yang tersedia',
  'admin.view': 'Melihat daftar dan detail admin',
  'admin.manage': 'Membuat, mengubah, dan menghapus admin',
  'product.view': 'Melihat daftar dan detail produk',
  'product.manage': 'Membuat, mengubah, dan menghapus produk',
  'user.view': 'Melihat daftar dan detail pengguna',
  'user.manage': 'Membuat, mengubah, dan menghapus pengguna',
  'order.view': 'Melihat daftar dan detail transaksi',
  'order.manage': 'Mengubah dan mengelola transaksi',
  'setting.view': 'Melihat pengaturan aplikasi',
  'setting.manage': 'Mengubah pengaturan aplikasi',
  'voucher.view': 'Melihat daftar dan detail voucher',
  'voucher.manage': 'Membuat, mengubah, dan menghapus voucher',
  'voucher_redemption.view': 'Melihat daftar penukaran voucher',
  'withdraw.view': 'Melihat daftar dan detail penarikan saldo',
  'withdraw.manage': 'Memproses dan mengelola penarikan saldo',
  'notification.view': 'Melihat daftar notifikasi',
  'notification.manage': 'Membuat, mengubah, dan menghapus notifikasi',
};

export function getPermissionDescription(permission: string): string {
  return PERMISSION_DESCRIPTIONS[permission] ?? 'Permission khusus aplikasi';
}

export function getPermissionLabel(permission: string): string {
  const [noun, action] = permission.split('.');
  if (!noun || !action) return permission.toUpperCase();

  const nounLabel = noun
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

  const actionLabel = action.charAt(0).toUpperCase() + action.slice(1);

  return `${actionLabel.toUpperCase()} ${nounLabel}`;
}
